import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Button } from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import Header from '../../components/Header';
import { LoadingBar } from '../../components/util/LoadingBar';
import {
  MTAssumptionsSection,
  MTCalc,
  MTCTAv2,
  MTDivider,
  MTHeader,
  MTLearnMore,
  MTLearnMoreItem,
  MTScorePanel,
  MTSkinny,
  MTSubcontent,
  MTSubcontentH1,
  MTSubcontentH2,
  MTSubcontentHR,
  MTSubcontentLabel,
  MTSubcontentP,
  MTSubheading,
  MTWide,
} from '../Microtools/layout';
import { CustomCTA } from '../Onboarding/PlanIntro';

import { runFullSimulation } from '../../actions/simulationActions';
import { trackEvent } from '../../actions/trackEventActions';
import { updateFrame } from '../../actions/uiActions';
import { wlPath, wlVar } from '../../helpers/whitelabel';

// for some reason Chrome on Windows needs a bit of extra height (hence +15px)
const IFrameContainer = styled.div`
  position: relative;
  overflow: hidden;
  height: ${props => (props.height ? `${props.height + 15}px` : '100%')};
`;

const StyledIFrame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${props => `${props.height}px` || '100%'};
  border: 0;
`;

export class DisabilityInsurance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      iFrameHeight: undefined,
    };
  }

  componentDidMount() {
    this.props.updateFrame('Disability: Protecting Your Income', 'family_2.jpg');
    // if (!this.props.results) {
    //   this.props.runFullSimulation();
    // }

    // wait for iFrame to load
    this.checkIfIFrameLoaded();
    //window.addEventListener('resize', this.updateIFrameHeight);
  }

  checkIfIFrameLoaded = () => {
    const iFrame = document.getElementById('calc-iframe');
    const iFrameDoc = iFrame.contentDocument || iFrame.contentWindow.document;
    if (iFrameDoc.readyState === 'complete' && iFrameDoc.getElementsByTagName('body').length) {
      // add a listener that will update the height if it's changed
      this.onElementHeightChange(iFrame, this.updateIFrameHeight);
      this.updateIFrameHeight();
      return;
    }
    window.setTimeout(this.checkIfIFrameLoaded, 100);
  };

  onElementHeightChange = (el, callback) => {
    let lastHeight = el.contentWindow.document.getElementsByTagName('body')[0].scrollHeight;
    let newHeight;
    (function run() {
      if (el.contentWindow.document.getElementsByTagName('body').length) {
        newHeight = el.contentWindow.document.getElementsByTagName('body')[0].scrollHeight;
        if (lastHeight != newHeight) {
          callback();
        }
      }

      lastHeight = newHeight;

      if (el.onElementHeightChangeTimer) {
        clearTimeout(el.onElementHeightChangeTimer);
      }

      el.onElementHeightChangeTimer = setTimeout(run, 200);
    })();
  };

  updateIFrameHeight = () => {
    this.setState({
      iFrameHeight: this.getIFrameHeight(),
    });
  };

  getIFrameHeight = () => {
    const newiFrameHeight = document
      .getElementById('calc-iframe')
      .contentWindow.document.getElementsByTagName('body')[0].scrollHeight;
    return newiFrameHeight;
  };

  componentWillUnmount() {
    //window.removeEventListener('resize', this.updateIFrameHeight);
  }

  render() {
    const { results } = this.props;

    if (!results) {
      return <LoadingBar />;
    }

    return (
      <div>
        <MTHeader title="" />
        <MTSkinny>
          <MTSubcontent noCard>
            <MTSubcontentP>
              While health insurance will often pay for your healthcare should you become ill or injured, it won’t
              replace the income lost from missing work.
            </MTSubcontentP>
          </MTSubcontent>
          <MTSubheading title="Protecting your family’s lifestyle." />
          <MTSubcontent noCard>
            <MTSubcontentP>
              Disability insurance, like other insurance, helps to prevent a major disruption of your family’s life by
              costs that you don’t have the means to meet without help - namely if you become sick or injured, and
              unable to work for an extended period. If you become disabled, can you still pay your mortgage, can you
              pay for your children’s education? For how long?
            </MTSubcontentP>
          </MTSubcontent>
          <MTSubcontent noCard>
            <MTSubcontentP>
              Use the calculator below to look at the general probabilities you’ll become disabled at different ages.
              With this in mind, we can compare the costs of your lost income to the costs of disability insurance,
              discussing tradeoffs.
            </MTSubcontentP>
          </MTSubcontent>

          {/* placeholder for iframe */}
          <IFrameContainer height={this.state.iFrameHeight}>
            <StyledIFrame id="calc-iframe" src="/calculators/disability_insurance" height={this.state.iFrameHeight} />
          </IFrameContainer>
        </MTSkinny>
        <CustomCTA heading="Considering Disability Insurance?" trackEvent={this.props.trackEvent}>
          <Typography
            tag="div"
            use="body1"
            className="pt-2"
            theme={wlVar('white_header') ? 'text-primary-on-light' : 'on-primary'}
          >
            We don’t recommend it for everyone, but if you’re interested in protecting your income, please get in touch.
            We’re happy to talk through your financial and family situation to decide whether insurance really makes
            sense, or another strategy may suit you better.
          </Typography>
        </CustomCTA>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    results: state.simulations.results,
  };
}

export default connect(mapStateToProps, { runFullSimulation, trackEvent, updateFrame })(DisabilityInsurance);
